var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloatingboy201(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f4e211;}.cls-2{fill:#8dd463;}.cls-3{fill:#ffbe9f;}.cls-4{fill:#ff715d;}.cls-5{fill:#f5f1e5;}.cls-6{fill:#2ca0ff;}.cls-7{clip-path:url(#clip-path);}.cls-11,.cls-8{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;}.cls-8{stroke-width:3px;}.cls-9{clip-path:url(#clip-path-2);}.cls-10{fill:#fff;}.cls-11{stroke-width:2px;}.cls-12{fill:#f2a286;}.cls-13{fill:#f9b093;}.cls-14{clip-path:url(#clip-path-3);}.cls-15{clip-path:url(#clip-path-4);}.cls-16{clip-path:url(#clip-path-5);}.cls-17{clip-path:url(#clip-path-6);}.cls-18{clip-path:url(#clip-path-7);}.cls-19{clip-path:url(#clip-path-8);}.cls-20{clip-path:url(#clip-path-9);}.cls-21{clip-path:url(#clip-path-10);}.cls-22{clip-path:url(#clip-path-11);}.cls-23{clip-path:url(#clip-path-12);}.cls-24{clip-path:url(#clip-path-13);}.cls-25{clip-path:url(#clip-path-14);}.cls-26{clip-path:url(#clip-path-15);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M888.56,284.74c15.81-21.26,26.39-45.94,41-68s35-42.42,61-47.76c36-7.41,73.2,17.82,88.09,51.43,17.64,39.84,7.92,89.12-20.37,122.25S985.39,393,941.83,392c-32.76-.72-92.14-13.33-113.88-41.29-12.63-16.26-2-21,12.58-28.53C859.9,312.23,875.23,302.66,888.56,284.74Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1303.28,95.77,1288.52,261c-1.45,16.16,9.8,30.6,25.46,32.66,17.17,2.26,40.46,4.84,64.66,6.07,15.25.77,28.51-10.67,30.48-26.24l21.16-167.65c2-16-8.58-30.78-24-33.58-20.93-3.8-50.69-7.28-77.93-3.53C1314.87,70.53,1304.52,81.86,1303.28,95.77Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M330.18,857l-9.44,27.6S158,916.24,167.33,970.18c0,0-5.53,62.84,195.4,36.15a85.86,85.86,0,0,0,59.7-36.47,116,116,0,0,0,6.23-10.18,122.5,122.5,0,0,0,14.86-61.46L330.18,857"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M243.21,935c14,2.9,28.45-.87,42-5.48,10.85-3.7,22-8.28,29.34-17s9.59-22.88,2-31.47c-7.2-8.15-19.73-8.38-30.5-6.87-21.61,3-46,10.42-63.74,23.62C204.3,911.15,228.29,931.92,243.21,935Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M202.2,471.45c-16.67.95-28.65,10.44-33.83,15.16,0,0-13.38-46.67-54.45-56.09A41.78,41.78,0,0,0,62.8,471.33c0,21.23,8.23,52.93,35.26,99.75,4.74,9.19,20.2,36.22,51.31,47.13,40,14,89.55-4.29,119.78-47.13,1.5-7.11,7-37-11.19-64.72C254.14,500.52,234,469.66,202.2,471.45Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M123.72,475.86c5.08,9.61,11.55,20.29,22.26,22.19,11.67,2.08,22.77-8.44,25-20.08s-2.37-23.55-8.36-33.77c-6.91-11.78-26.54-32.47-41.41-19.66C105.86,437.75,116.34,461.88,123.72,475.86Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M695.76,433.19c-34.51-48.44-106.32-120.8-225.09-115.81-28.51,1.19-50.93,25.2-49.4,53.69,1.57,29.05,19.45,73.26,75.72,139.62,40.49,71.8,121,94.57,171.15,66.05a88.83,88.83,0,0,0,29.13-27.14C721.5,514.57,720.48,467.87,695.76,433.19Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M850.08,570.42c14.24,38.25-4.52,81.12-42.07,97.12-43.73,18.62-115.92,36.54-203.47,9.67,0,0-50.61-14.7-69.62,18.24,0,0-8.86,11.58-12.29,47,0,0-5.23,97.83-81.14,161.31,0,0-74.05,5.69-113.33-41.21,0,0,34.21-164.24,61.27-231.78,0,0,27-110,117.39-145.89A408.34,408.34,0,0,1,660.4,472.12c42.16,4.59,83.37,11.57,109.57,21.78,7.81,1.57,42.34,14.15,68.42,53.56A112.9,112.9,0,0,1,850.08,570.42Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M479.93,317.13S327.94,322,202.2,471.45a118.6,118.6,0,0,0,66.95,99.63c36.08-27.92,68.18-45.86,88.51-59.52,49.12-33,108-72.5,146.84-98.46,16.53-11,25.83-30.43,23.19-50.12a53.15,53.15,0,0,0-47.76-45.85"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M881.11,307.53s61.81-21.92,133.1,19.24c0,0-76.52,33.09-38.26,143.23,0,0-19,140.86-147.33,189.25,0,0-16.38-7-21-55.7A144.26,144.26,0,0,0,698.7,477l-3.22-.76s-1.92-58.34,62.6-58.34c0,0-.12-74,68-126Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M806.48,258c.26-11.88,10.76-22.62,22.62-23.14a34.81,34.81,0,1,1,60.58-33.39,31.41,31.41,0,1,1,61.69,10.82c6.27-6.26,17.83-4.6,23.56,2.15s6.16,16.9,2.88,25.13-9.67,14.83-16.55,20.41c8-2.43,16.52,5.32,16.85,13.66s-6,16.28-14,19.3-16.95,1.88-24.8-1.31-14.77-8.29-21.58-13.34-13.69-10.18-21.51-13.44c-12-5-25.72-5.29-38.23-1.74a70.77,70.77,0,0,0-16.94,7.4c-4.63,2.77-9.73,8.89-15,10.14C815.19,283.29,806.3,266.9,806.48,258Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 887.03,
    cy: 276.79,
    rx: 63.91,
    ry: 64.88
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 822.9,
    cy: 271.84,
    r: 11.56
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 954.92,
    cy: 285.95,
    r: 11.56
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M898.58,288.71c-4.71,5.45-4.59,12.7-1.33,16.05,3.83,3.92,13.1,3.6,18.32-3.67Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "floating boy2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hood"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M888.56,284.74c15.81-21.26,26.39-45.94,41-68s35-42.42,61-47.76c36-7.41,73.2,17.82,88.09,51.43,17.64,39.84,7.92,89.12-20.37,122.25S985.39,393,941.83,392c-32.76-.72-92.14-13.33-113.88-41.29-12.63-16.26-2-21,12.58-28.53C859.9,312.23,875.23,302.66,888.56,284.74Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1004.43,197.22c8.69,3.24,27.58,11.74,41.07,31.54,26.51,38.91,7.24,84.86,5.7,88.37"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "phone"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1303.28,95.77,1288.52,261c-1.45,16.16,9.8,30.6,25.46,32.66,17.17,2.26,40.46,4.84,64.66,6.07,15.25.77,28.51-10.67,30.48-26.24l21.16-167.65c2-16-8.58-30.78-24-33.58-20.93-3.8-50.69-7.28-77.93-3.53C1314.87,70.53,1304.52,81.86,1303.28,95.77Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1303.45,242.65l16-151.68a10,10,0,0,1,10.42-9l70.82,3.23A10,10,0,0,1,1410.19,96l-11.33,148.45a10,10,0,0,1-10,9.26h-75.46A10,10,0,0,1,1303.45,242.65Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 1422.07,
    y1: 94.03,
    x2: 1415.89,
    y2: 160.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 1344.02,
    cy: 269.03,
    rx: 5.96,
    ry: 6.3
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "thum"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1303.67,138.64c9-6.66,21.36-11.82,31.18-6.39s12,19.52,7.61,29.91-13.45,17.94-22.19,25.07a92.34,92.34,0,0,1,4.66,69.36c-2.06,6.14-4.82,12.46-3.68,18.84,1.45,8.12,9.12,14,17.16,15.89s16.43.65,24.59-.62c-10.85-12.38-7.24-34.38,7-42.64a32.49,32.49,0,0,1,9.23-57.33c-12.18-8-12.78-27-4.66-39.11,6.89-10.29,19.16-17,31.52-16.38s24.22,9.08,28,20.86-1.24,26.07-12.06,32.1a27.18,27.18,0,0,1-6.18,50.91c1.7.71,12.82,5.55,16.67,17.77,3.68,11.72-1.47,24.41-10.64,32.07a30.87,30.87,0,0,1-16.66,7.28c-5.31.48-13.6-2.65-17,3.17-10.29,17.71-30.36,24.45-50.87,23.47-68.39-3.27-87.37-88.06-66.77-140.46C1277.4,165.18,1288.72,149.65,1303.67,138.64Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "left_fingers",
    "data-name": "left fingers"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M453.62,102.64c-7.44,3.48-12.35,11.17-13.94,19.23s-.22,16.45,2.27,24.28a87.08,87.08,0,0,0,15.16,28.19c2.68,3.33,5.68,6.51,9.44,8.55s8.39,2.81,12.34,1.19c4.1-1.69,6.9-5.71,8.13-10s1.09-8.79.8-13.22C486.7,143.91,483.7,88.63,453.62,102.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M475.55,94.85c-7.45,3.47-12.36,11.16-13.95,19.22s-.21,16.45,2.28,24.28A87,87,0,0,0,479,166.55c2.68,3.32,5.68,6.51,9.43,8.55s8.39,2.8,12.34,1.18c4.11-1.69,6.9-5.71,8.13-10s1.1-8.79.8-13.22C508.62,136.11,505.62,80.83,475.55,94.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M561,243.22c18.77-2.46,34.86-17.42,40.22-35.57,4.06-13.72,2.18-29.45-6.45-40.85s-24.32-17.54-38-13.42L526,99.38c-4.29-7.53-10.14-16-18.81-16.15-4.73-.06-9.2,2.63-12.19,6.31s-4.68,8.23-5.86,12.82A74,74,0,0,0,500,162.51a92.65,92.65,0,0,0-44.81,22.87c-3.35,3.11-6.54,6.58-8.2,10.83s-1.55,9.45,1.31,13c3.42,4.25,9.5,5.05,14.95,5.19,16.76.42,31.35-3.91,47.41-7.39,5.09,9.44,6.93,17.27,15.34,24.94C536.21,241.24,547.78,243.22,561,243.22Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "shoe_1",
    "data-name": "shoe 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M330.18,857l-9.44,27.6S158,916.24,167.33,970.18c0,0-5.53,62.84,195.4,36.15a85.86,85.86,0,0,0,59.7-36.47,116,116,0,0,0,6.23-10.18,122.5,122.5,0,0,0,14.86-61.46L330.18,857"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M243.21,935c14,2.9,28.45-.87,42-5.48,10.85-3.7,22-8.28,29.34-17s9.59-22.88,2-31.47c-7.2-8.15-19.73-8.38-30.5-6.87-21.61,3-46,10.42-63.74,23.62C204.3,911.15,228.29,931.92,243.21,935Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M230,900.1a46.16,46.16,0,0,1,20.34,34.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M261.17,893A50.83,50.83,0,0,1,277,933.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M285.9,888.25a49,49,0,0,1,13,38.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M181.7,969s76.36,59.16,224.94,2.75"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "shoe_2",
    "data-name": "shoe 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M202.2,471.45c-16.67.95-28.65,10.44-33.83,15.16,0,0-13.38-46.67-54.45-56.09A41.78,41.78,0,0,0,62.8,471.33c0,21.23,8.23,52.93,35.26,99.75,4.74,9.19,20.2,36.22,51.31,47.13,40,14,89.55-4.29,119.78-47.13,1.5-7.11,7-37-11.19-64.72C254.14,500.52,234,469.66,202.2,471.45Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M123.72,475.86c5.08,9.61,11.55,20.29,22.26,22.19,11.67,2.08,22.77-8.44,25-20.08s-2.37-23.55-8.36-33.77c-6.91-11.78-26.54-32.47-41.41-19.66C105.86,437.75,116.34,461.88,123.72,475.86Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M114.12,453.65a32.71,32.71,0,0,0,25.39-18.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M123.77,475a49.65,49.65,0,0,0,30.28-23.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M135.14,492.06a60.23,60.23,0,0,0,29.42-24.69"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M76.45,466.87s27.52,145.84,117.63,139"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "upper_eg_2",
    "data-name": "upper eg 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M695.76,433.19c-34.51-48.44-106.32-120.8-225.09-115.81-28.51,1.19-50.93,25.2-49.4,53.69,1.57,29.05,19.45,73.26,75.72,139.62,40.49,71.8,121,94.57,171.15,66.05a88.83,88.83,0,0,0,29.13-27.14C721.5,514.57,720.48,467.87,695.76,433.19Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M709.23,526.14S628.15,340.3,402.51,351.31L397,383s145.84-22,276.54,158.21l35.68-15"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "leg_1",
    "data-name": "leg 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M850.08,570.42c14.24,38.25-4.52,81.12-42.07,97.12-43.73,18.62-115.92,36.54-203.47,9.67,0,0-50.61-14.7-69.62,18.24,0,0-8.86,11.58-12.29,47,0,0-5.23,97.83-81.14,161.31,0,0-74.05,5.69-113.33-41.21,0,0,34.21-164.24,61.27-231.78,0,0,27-110,117.39-145.89A408.34,408.34,0,0,1,660.4,472.12c42.16,4.59,83.37,11.57,109.57,21.78,7.81,1.57,42.34,14.15,68.42,53.56A112.9,112.9,0,0,1,850.08,570.42Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1066,713.39a934.5,934.5,0,0,1,272.25-109c9.07-2,18.54-4,27.57-1.75s17.43,9.85,17.4,19.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M806.48,538.41S614.55,478.09,500.3,565.47q-5.39,4.11-10.92,8c-16.23,11.62-74.9,79.92-124.21,337.74l47,8.26s16.07-154.34,76.53-271.24c18.34-35.45,54.13-58.61,92.67-69,54.21-14.57,143.68-28.08,239.28,1.77Z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "lower_leg",
    "data-name": "lower leg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M479.93,317.13S327.94,322,202.2,471.45a118.6,118.6,0,0,0,66.95,99.63c36.08-27.92,68.18-45.86,88.51-59.52,49.12-33,108-72.5,146.84-98.46,16.53-11,25.83-30.43,23.19-50.12a53.15,53.15,0,0,0-47.76-45.85"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M539.54,371.6S399.08,312.78,205.78,518.46L219.39,542S415.25,362.63,516.54,406.15h0S556.86,401.61,539.54,371.6Z"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "arm_2",
    "data-name": "arm 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M832.62,304.06s-17.1-37.12-75.93-27.27c0,0-43.71,2.76-74.84-28.37,0,0-37.78-45.36-80.13-58-3.34.32-22.54,2.54-35.58,19.48-15.82,20.56-8.62,44.71-7.91,46.95,5.39,21.31,16.7,49.05,35.19,79.22,25.27,41.24,65.91,85.74,127.36,98.78,4.38.48,55.26,5.13,90.28-35.59C846.34,358.23,833.74,308.18,832.62,304.06Z"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "body"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M881.11,307.53s61.81-21.92,133.1,19.24c0,0-76.52,33.09-38.26,143.23,0,0-19,140.86-147.33,189.25,0,0-16.38-7-21-55.7A144.26,144.26,0,0,0,698.7,477l-3.22-.76s-1.92-58.34,62.6-58.34c0,0-.12-74,68-126Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M807.63,410.59A322.15,322.15,0,0,0,890,440.92a6,6,0,0,1,2.55,10.49c-14.42,11.92-38.42,36.6-39.8,69.73a6,6,0,0,1-8.69,5.07c-19.48-9.92-65.52-35.42-83.22-62.84a5.93,5.93,0,0,1-.55-5.41c3.08-7.85,13.84-30.25,41.25-47.21A6,6,0,0,1,807.63,410.59Z"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "arm_1",
    "data-name": "arm 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1014.21,326.77s115.17,21.84,257.82-82.52c3.8-.22,25.93-1.13,44,15.85,20,18.78,18.61,44.06,18.37,47.43-17.14,29.2-52.08,70.28-103.83,110.79C1166.08,468.79,1076.47,509.41,976,470a82.82,82.82,0,0,1-26.79-80.65C956.34,357.76,981.91,333.14,1014.21,326.77Z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "face"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M806.48,258c.26-11.88,10.76-22.62,22.62-23.14a34.81,34.81,0,1,1,60.58-33.39,31.41,31.41,0,1,1,61.69,10.82c6.27-6.26,17.83-4.6,23.56,2.15s6.16,16.9,2.88,25.13-9.67,14.83-16.55,20.41c8-2.43,16.52,5.32,16.85,13.66s-6,16.28-14,19.3-16.95,1.88-24.8-1.31-14.77-8.29-21.58-13.34-13.69-10.18-21.51-13.44c-12-5-25.72-5.29-38.23-1.74a70.77,70.77,0,0,0-16.94,7.4c-4.63,2.77-9.73,8.89-15,10.14C815.19,283.29,806.3,266.9,806.48,258Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M926.9,184.8a47,47,0,0,0-11.25-3.35,9.27,9.27,0,0,0-4.06,0,3.65,3.65,0,0,0-2.71,2.77c-.26,1.9,1.53,3.5,3.34,4.15s3.82.76,5.5,1.69c.94.52,1.82,1.56,1.46,2.57a2.29,2.29,0,0,1-2.23,1.21,12.74,12.74,0,0,0-2.69,0c-2.33.51-3.1,3.79-1.87,5.83s3.65,3,6,3.58a28.55,28.55,0,0,0,6.51.78,7.33,7.33,0,0,0,3.19-.54,2.94,2.94,0,0,0,1.76-2.54c0-1.19-1-2.12-1.7-3.05s-1.36-2.25-.7-3.24,2.07-1,3.15-.56a12.83,12.83,0,0,0,3.23,1.22,3.9,3.9,0,0,0,3.91-3.41,5.93,5.93,0,0,0-2.12-5.07,13,13,0,0,0-5.09-2.52,32.48,32.48,0,0,0-14.34-.86"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 887.03,
    cy: 276.79,
    rx: 63.91,
    ry: 64.88
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M914.88,272.82s3.66,14.41-2.63,17"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 867.09,
    cy: 279.85,
    r: 7.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.17,266a33.28,33.28,0,0,0,2.53-25.65,16.08,16.08,0,0,0,24.89-13.53c11.76,7.13,28.64,4.07,37.15-6.73a24.46,24.46,0,0,0,33.81,32.18c-2.3,4.6-4,9.81-3,14.86s5.4,9.69,10.54,9.46c4.54-.2,8.27-4.11,9.53-8.47s.51-9.05-.69-13.43a67.39,67.39,0,0,0-76.79-48.5c-17.25,3.07-33,13-43.88,26.81-7.84,9.94-16.51,25.5-16.63,38.58C820.48,288.55,839.63,272.44,843.17,266Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.32,145.85a27.34,27.34,0,0,1-.69-11.44,14.2,14.2,0,0,1,6-9.48c5.69-3.57,13.68-1.17,18.14,3.87s6.05,12,6.65,18.69c.71,7.92,2.66,27.34-10.45,25.53C868.43,171.56,861.48,154.69,859.32,145.85Z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "ear"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 822.9,
    cy: 271.84,
    r: 11.56
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M816.48,271.84a8.49,8.49,0,0,1,4.55-5.11,8.67,8.67,0,0,1,7.68.65"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 954.92,
    cy: 285.95,
    r: 11.56
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M961.15,287.49a8.46,8.46,0,0,0-3.2-6.05,8.68,8.68,0,0,0-7.61-1.21"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "eyebrow_1",
    "data-name": "eyebrow 1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 893.17,
    cy: 263.67,
    rx: 8.48,
    ry: 4.46,
    transform: "translate(-37.51 296.96) rotate(-18.5)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "eye1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 895.44,
    cy: 276.79,
    r: 3.14
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "eye2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 925.95,
    cy: 277.55,
    r: 3.16
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "mouth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M898.58,288.71c-4.71,5.45-4.59,12.7-1.33,16.05,3.83,3.92,13.1,3.6,18.32-3.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M892.3,299.94s11.78-2.29,12.94,8.72C905.24,308.66,894.94,309.57,892.3,299.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M902.27,289.74h0a5.55,5.55,0,0,0,1.07,7.67l1.52,1.18a5.55,5.55,0,0,0,7.8-1l.05-.07Z"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "eyebrow_2",
    "data-name": "eyebrow 2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 927.95,
    cy: 264.42,
    rx: 4.29,
    ry: 7.45,
    transform: "translate(291.47 989.61) rotate(-64.63)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "lines"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M713.19,433c16.45-16.45,44.89-15.12,44.89-15.12s-.18-35.25,21.85-73.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M950.94,452.91s12.73,12.66,25,17.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M491.85,94.59s-12.71,31.76,8.17,67.92"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 451.07,
    y1: 448.86,
    x2: 465.8,
    y2: 414.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1344.59,152.56c0,19.33-24.32,34.67-24.32,34.67s20.73,35.44,0,77.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1379.23,190.73a132.81,132.81,0,0,1,42.84-2.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1370,248.06s24.66-8.95,45.89-8.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M979.86,327.23s38.59-13.15,89.36.3a248,248,0,0,0,37.2-6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M822.34,418a527.63,527.63,0,0,0,58.95,20.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M763.62,468.14s19.43,22.63,40.78,35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M480.76,168.6s-33.49-34.91-13.25-67.37"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloatingboy201);
export default __webpack_public_path__ + "static/media/floating boy2-01.941172f1762482fa50904ce0a9927e56.svg";
export { ForwardRef as ReactComponent };